import React from 'react';
import { render } from 'react-snapshot';
import { BrowserRouter } from 'react-router-dom';
import Analytics from 'react-ga';
import config from './config';
import './index.css';
import App from './components/App';

Analytics.initialize(config.GOOGLE_ANALYTICS_ID);

render((
  <BrowserRouter>
    <App/>
  </BrowserRouter>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js